import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import AgentCreators from '@/components/agent_creators.vue'
import WorkHistory from '@/components/work_history.vue'
import SelectButton from 'primevue/selectbutton'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['calendar']
  connect() {
    const app = createApp(AgentCreators, {
      agent: JSON.parse(this.element.dataset.agent),
      creators: JSON.parse(this.element.dataset.creators),
      shiftOptions: JSON.parse(this.element.dataset.shiftOptions)
    })
    app.use(PrimeVue, {
      locale: {
        accept: 'はい',
        reject: 'いいえ',
        choose: '選択',
        upload: 'アップロード',
        cancel: 'キャンセル',
        dayNames: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日'
        ],
        dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        today: '今日',
        clear: 'クリア',
        weekHeader: '週',
        firstDayOfWeek: 1,
        dateFormat: 'yy/mm/dd',
        weak: '弱い',
        medium: '普通',
        strong: '強い',
        passwordPrompt: 'パスワードを入力'
      }
    })
    app.component('WorkHistory', WorkHistory)
    app.component('SelectButton', SelectButton)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.calendarTarget)
  }
}
